import React from "react";
function PeriodEducationalContent() {
  return (
    <div className="row" style={{ marginTop: "20px" }}>
      <div className="col-12 col-md-8">
        <div className="info-sections-container">
          <div className="info-section">
            <div className="info-section-header">
              <strong>فهم الدورة الشهرية - دليل شامل</strong>
            </div>
            <div className="info-section-body">
              <p style={{ lineHeight: "1.8" }}>
                <strong>الدورة الشهرية</strong> هي عملية طبيعية تحدث في جسم المرأة كل شهر،
                تبدأ من اليوم الأول للحيض وتستمر حتى اليوم الأول من الحيض التالي. هذه العملية
                جزء من الجهاز التناسلي الأنثوي وتحدث استعداداً لاحتمال حدوث حمل.
              </p>
              <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                مراحل الدورة الشهرية:
              </h3>
              <div
                className="alert alert-info"
                style={{ lineHeight: "1.8", backgroundColor: "#d1ecf1" }}
              >
                <strong>1. مرحلة الحيض (أيام 1-7):</strong>
                <br />
                تنزل بطانة الرحم على شكل دم ونسيج من المهبل. هذه هي الفترة التي نسميها "الدورة"
                أو "الحيض" وتستمر عادةً من 3 إلى 7 أيام.
                <br/>                <strong>2. المرحلة الجرابية (أيام 1-13):</strong>
                <br />
                تبدأ مع أول يوم من الحيض وتستمر حتى الإباضة. خلال هذه الفترة، تنمو البويضات
                في المبيض داخل أكياس صغيرة تسمى الجريبات، وتبدأ بطانة الرحم بالنمو مجدداً.
                <br/>                <strong>3. مرحلة الإباضة (اليوم 14 تقريباً):</strong>
                <br />
                يتم إطلاق بويضة ناضجة من المبيض. هذه هي أكثر فترة خصوبة في الدورة، وتحدث
                عادةً في منتصف الدورة (اليوم 14 في دورة مدتها 28 يوماً).
                <br/>                <strong>4. المرحلة الأصفرية (أيام 15-28):</strong>
                <br />
                بعد خروج البويضة، يتحول الجريب إلى جسم أصفر ينتج هرمون البروجسترون. إذا لم
                يحدث حمل، ينخفض مستوى الهرمونات وتبدأ دورة جديدة.
              </div>
              <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                كيفية حساب الدورة الشهرية:
              </h3>
              <ol style={{ lineHeight: "1.8" }}>
                <li>
                  <strong>حددي اليوم الأول:</strong> أول يوم من الحيض (عندما يبدأ النزيف الفعلي)
                  هو اليوم الأول من دورتك
                </li>
                <li>
                  <strong>عدّي الأيام:</strong> احسبي عدد الأيام من اليوم الأول للحيض حتى
                  اليوم الذي يسبق الحيض التالي
                </li>
                <li>
                  <strong>طول الدورة:</strong> هذا العدد هو طول دورتك (عادةً 21-35 يوماً)
                </li>
                <li>
                  <strong>تتبعي لعدة أشهر:</strong> سجلي طول دورتك لمدة 3-6 أشهر لمعرفة
                  متوسط طول دورتك
                </li>
              </ol>
              <div
                className="alert alert-success mt-3"
                style={{ lineHeight: "1.8", backgroundColor: "#d4edda" }}
              >
                <strong>مثال عملي:</strong>
                <br />
                إذا بدأت دورتك في 1 يناير وجاءت الدورة التالية في 29 يناير، فإن طول دورتك
                28 يوماً.
                <br/>                <strong>حساب الدورة القادمة:</strong> أضيفي 28 يوماً إلى 1 يناير، ستكون
                الدورة القادمة متوقعة في 29 يناير.
              </div>
              <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                أهمية تتبع الدورة الشهرية:
              </h3>
              <ul style={{ lineHeight: "1.8" }}>
                <li>معرفة ما إذا كانت دورتك منتظمة أم لا</li>
                <li>التخطيط للحمل من خلال تحديد أيام الخصوبة</li>
                <li>تجنب الحمل بمعرفة الأيام الأكثر خصوبة</li>
                <li>اكتشاف أي تغييرات غير طبيعية مبكراً</li>
                <li>الاستعداد النفسي والجسدي لقدوم الدورة</li>
                <li>تحديد موعد زيارات الطبيب بشكل أفضل</li>
              </ul>
            </div>
          </div>
          <div className="info-section">
            <div className="info-section-header">
              <strong>أيام التبويض والخصوبة</strong>
            </div>
            <div className="info-section-body">
              <p style={{ lineHeight: "1.8" }}>
                <strong>التبويض</strong> هو إطلاق بويضة ناضجة من المبيض، وهي أهم فترة إذا
                كنتِ تحاولين الحمل أو تتجنبينه.
              </p>
              <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                متى يحدث التبويض؟
              </h3>
              <div
                className="alert alert-warning"
                style={{ lineHeight: "1.8", backgroundColor: "#fff3cd" }}
              >
                <strong>القاعدة الأساسية:</strong>
                <br />
                يحدث التبويض عادةً قبل <strong>14 يوماً</strong> من موعد الدورة القادمة.
                <br/>                <strong>أمثلة:</strong>
                <ul style={{ marginTop: "10px" }}>
                  <li>دورة 28 يوماً: التبويض في اليوم 14</li>
                  <li>دورة 30 يوماً: التبويض في اليوم 16</li>
                  <li>دورة 32 يوماً: التبويض في اليوم 18</li>
                </ul>
              </div>
              <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                فترة الخصوبة (النافذة الخصبة):
              </h3>
              <p style={{ lineHeight: "1.8" }}>
                فترة الخصوبة هي الأيام التي يمكن فيها حدوث حمل، وتشمل:
              </p>
              <ul style={{ lineHeight: "1.8" }}>
                <li>
                  <strong>5 أيام قبل التبويض:</strong> الحيوانات المنوية يمكن أن تعيش حتى
                  5 أيام داخل الجسم
                </li>
                <li>
                  <strong>يوم التبويض:</strong> أكثر يوم خصوبة
                </li>
                <li>
                  <strong>يوم واحد بعد التبويض:</strong> البويضة تعيش 12-24 ساعة فقط
                </li>
              </ul>
              <div
                className="alert alert-success"
                style={{ lineHeight: "1.8", backgroundColor: "#d4edda" }}
              >
                <strong>إجمالاً:</strong> فترة الخصوبة تمتد لحوالي <strong>6 أيام</strong> في
                كل دورة.
              </div>
              <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                علامات التبويض:
              </h3>
              <ol style={{ lineHeight: "1.8" }}>
                <li>
                  <strong>تغير في الإفرازات المهبلية:</strong> تصبح شفافة ومطاطة تشبه بياض
                  البيض
                </li>
                <li>
                  <strong>ارتفاع طفيف في درجة الحرارة:</strong> بعد التبويض مباشرة ترتفع
                  درجة حرارة الجسم قليلاً
                </li>
                <li>
                  <strong>ألم خفيف في جانب البطن:</strong> بعض النساء يشعرن بألم خفيف في
                  جانب واحد
                </li>
                <li>
                  <strong>زيادة الرغبة الجنسية:</strong> هرمونات التبويض قد تزيد الرغبة
                </li>
                <li>
                  <strong>ألم خفيف في الثدي:</strong> نتيجة التغيرات الهرمونية
                </li>
              </ol>
              <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                طرق تحديد التبويض بدقة:
              </h3>
              <ul style={{ lineHeight: "1.8" }}>
                <li>
                  <strong>اختبارات التبويض المنزلية:</strong> تكشف عن ارتفاع هرمون LH قبل
                  التبويض بـ24-36 ساعة
                </li>
                <li>
                  <strong>قياس درجة الحرارة الأساسية:</strong> كل صباح قبل النهوض من
                  السرير
                </li>
                <li>
                  <strong>مراقبة الإفرازات:</strong> ملاحظة التغيرات اليومية
                </li>
                <li>
                  <strong>السونار:</strong> عند الطبيب لمتابعة نمو البويضة
                </li>
              </ul>
              <div
                className="alert alert-info mt-3"
                style={{ lineHeight: "1.8", backgroundColor: "#d1ecf1" }}
              >
                <strong>💡 نصيحة:</strong> إذا كنتِ تحاولين الحمل، استخدمي{" "}
                <strong>حاسبة الدورة الشهرية</strong> أعلاه لتحديد أيام الخصوبة، ثم استخدمي
                اختبارات التبويض المنزلية للتأكد من موعد التبويض الدقيق.
              </div>
            </div>
          </div>
          <div className="info-section">
            <div className="info-section-header">
              <strong>الدورة المنتظمة مقابل غير المنتظمة</strong>
            </div>
            <div className="info-section-body">
              <p style={{ lineHeight: "1.8" }}>
                معرفة ما إذا كانت دورتك منتظمة أم لا مهم جداً لصحتك الإنجابية.
              </p>
              <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                الدورة الشهرية المنتظمة:
              </h3>
              <div
                className="alert alert-success"
                style={{ lineHeight: "1.8", backgroundColor: "#d4edda" }}
              >
                <strong>الخصائص:</strong>
                <ul style={{ marginTop: "10px" }}>
                  <li>تأتي كل 21-35 يوماً</li>
                  <li>الفرق بين أقصر وأطول دورة لا يتجاوز 7-9 أيام</li>
                  <li>يمكن توقع موعدها تقريباً</li>
                  <li>مدة الحيض تتراوح بين 3-7 أيام</li>
                </ul>
                <br />
                <strong>مثال:</strong> إذا كانت دوراتك 26، 28، 27، 29 يوماً - هذه دورة منتظمة
              </div>
              <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                الدورة الشهرية غير المنتظمة:
              </h3>
              <div
                className="alert alert-warning"
                style={{ lineHeight: "1.8", backgroundColor: "#fff3cd" }}
              >
                <strong>العلامات:</strong>
                <ul style={{ marginTop: "10px" }}>
                  <li>تأتي بفترات متباعدة جداً (أكثر من 35 يوماً) أو قريبة جداً (أقل من 21 يوماً)</li>
                  <li>الفرق الكبير بين طول الدورات (أكثر من 9 أيام)</li>
                  <li>صعوبة في توقع موعد الدورة</li>
                  <li>تغير كبير في كمية أو مدة النزيف</li>
                </ul>
                <br />
                <strong>مثال:</strong> دورات بطول 22، 35، 28، 40 يوماً - هذه دورة غير منتظمة
              </div>
              <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                أسباب عدم انتظام الدورة:
              </h3>
              <ol style={{ lineHeight: "1.8" }}>
                <li>
                  <strong>التوتر والضغط النفسي:</strong> يؤثر على الهرمونات
                </li>
                <li>
                  <strong>تغيرات الوزن:</strong> نقصان أو زيادة مفاجئة في الوزن
                </li>
                <li>
                  <strong>متلازمة تكيس المبايض (PCOS):</strong> اضطراب هرموني شائع
                </li>
                <li>
                  <strong>مشاكل الغدة الدرقية:</strong> فرط أو قصور النشاط
                </li>
                <li>
                  <strong>الرياضة المفرطة:</strong> خاصةً مع نقص الوزن
                </li>
                <li>
                  <strong>الرضاعة الطبيعية:</strong> تؤثر على الدورة بشكل طبيعي
                </li>
                <li>
                  <strong>قرب سن اليأس:</strong> في الأربعينات تصبح الدورة غير منتظمة
                </li>
                <li>
                  <strong>بعض الأدوية:</strong> مثل مضادات الاكتئاب أو مميعات الدم
                </li>
              </ol>
              <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                متى تزورين الطبيب؟
              </h3>
              <div
                className="alert alert-danger"
                style={{ lineHeight: "1.8", backgroundColor: "#f8d7da" }}
              >
                <strong>⚠️ استشيري الطبيب إذا:</strong>
                <ul style={{ marginTop: "10px" }}>
                  <li>توقفت الدورة فجأة لأكثر من 3 أشهر (وأنتِ لستِ حاملاً)</li>
                  <li>أصبحت الدورة غير منتظمة بعد أن كانت منتظمة</li>
                  <li>تحدث الدورة أكثر من مرة كل 21 يوماً أو أقل من مرة كل 35 يوماً</li>
                  <li>النزيف شديد جداً (تغيير الفوطة كل ساعة)</li>
                  <li>النزيف يستمر أكثر من 7 أيام</li>
                  <li>ألم شديد غير معتاد</li>
                  <li>نزيف بين الدورات</li>
                </ul>
              </div>
              <div
                className="alert alert-info mt-3"
                style={{ lineHeight: "1.8", backgroundColor: "#d1ecf1" }}
              >
                <strong>💡 ملاحظة:</strong> من الطبيعي أن تكون الدورة غير منتظمة في السنوات
                القليلة الأولى بعد البلوغ، وكذلك في السنوات القريبة من سن اليأس.
              </div>
            </div>
          </div>
        </div>
        <br />
        {/* FAQ Section */}
        <h2 style={{ fontSize: "20px", marginBottom: "15px" }}>
          أسئلة متكررة حول الدورة الشهرية
        </h2>
        <div className="info-sections-container">
          <div className="info-section">
            <div className="info-section-header">
              <h3 style={{ fontSize: "16px" }}>
                كيف أحسب موعد الدورة الشهرية القادمة؟
              </h3>
            </div>
            <div className="info-section-body">
              <p style={{ lineHeight: "1.8" }}>
                لحساب موعد <strong>الدورة الشهرية القادمة</strong>، اتبعي هذه الخطوات
                البسيطة:
              </p>
              <h4 style={{ fontSize: "16px", marginTop: "15px" }}>
                <strong>الطريقة الأولى: الحساب اليدوي</strong>
              </h4>
              <ol style={{ lineHeight: "1.8" }}>
                <li>سجلي تاريخ اليوم الأول من آخر دورة</li>
                <li>أضيفي عدد أيام دورتك (مثلاً 28 يوماً)</li>
                <li>النتيجة هي موعد الدورة القادمة المتوقع</li>
              </ol>
              <div className="alert alert-info" style={{ lineHeight: "1.8" }}>
                <strong>مثال:</strong>
                <br />
                آخر دورة: 1 يناير
                <br />
                طول الدورة: 28 يوماً
                <br />
                الدورة القادمة: 1 يناير + 28 يوماً = <strong>29 يناير</strong>
              </div>
              <h4 style={{ fontSize: "16px", marginTop: "15px" }}>
                <strong>الطريقة الثانية: حاسبة الدورة الإلكترونية</strong>
              </h4>
              <p style={{ lineHeight: "1.8" }}>
                استخدمي <strong>حاسبة الدورة الشهرية</strong> في أعلى الصفحة للحصول على:
              </p>
              <ul style={{ lineHeight: "1.8" }}>
                <li>مواعيد 12 دورة قادمة</li>
                <li>أيام التبويض لكل دورة</li>
                <li>فترات الخصوبة</li>
                <li>تقويم شامل ومنظم</li>
              </ul>
              <h4 style={{ fontSize: "16px", marginTop: "15px" }}>
                <strong>نصائح لحساب دقيق:</strong>
              </h4>
              <ul style={{ lineHeight: "1.8" }}>
                <li>تتبعي دورتك لمدة 3-6 أشهر لمعرفة متوسط طولها</li>
                <li>استخدمي تطبيقات تتبع الدورة لسهولة التسجيل</li>
                <li>تذكري أن هذه تقديرات - قد تتأخر أو تتقدم بيومين</li>
              </ul>
            </div>
          </div>
          <div className="info-section">
            <div className="info-section-header">
              <h3 style={{ fontSize: "16px" }}>
                ما هو طول الدورة الشهرية الطبيعي؟
              </h3>
            </div>
            <div className="info-section-body">
              <p style={{ lineHeight: "1.8" }}>
                <strong>طول الدورة الشهرية الطبيعي</strong> يختلف من امرأة لأخرى، ولكن
                هناك نطاق طبيعي محدد طبياً:
              </p>
              <div
                className="alert alert-success"
                style={{ lineHeight: "1.8", backgroundColor: "#d4edda" }}
              >
                <strong>النطاق الطبيعي:</strong>
                <ul style={{ marginTop: "10px" }}>
                  <li>
                    <strong>طول الدورة:</strong> 21-35 يوماً (من اليوم الأول للحيض حتى
                    اليوم الأول للحيض التالي)
                  </li>
                  <li>
                    <strong>المتوسط الشائع:</strong> 28 يوماً
                  </li>
                  <li>
                    <strong>مدة الحيض:</strong> 3-7 أيام
                  </li>
                  <li>
                    <strong>كمية الدم:</strong> 30-40 مل (ملعقتان كبيرتان تقريباً)
                  </li>
                </ul>
              </div>
              <h4 style={{ fontSize: "16px", marginTop: "15px" }}>
                <strong>أمثلة على دورات طبيعية:</strong>
              </h4>
              <ul style={{ lineHeight: "1.8" }}>
                <li>دورة 24 يوماً - طبيعية (قصيرة نسبياً)</li>
                <li>دورة 28 يوماً - طبيعية (الأكثر شيوعاً)</li>
                <li>دورة 32 يوماً - طبيعية (طويلة نسبياً)</li>
              </ul>
              <h4 style={{ fontSize: "16px", marginTop: "15px" }}>
                <strong>متى تعتبر الدورة غير طبيعية؟</strong>
              </h4>
              <div
                className="alert alert-warning"
                style={{ lineHeight: "1.8", backgroundColor: "#fff3cd" }}
              >
                <ul style={{ marginTop: "10px" }}>
                  <li>أقصر من 21 يوماً</li>
                  <li>أطول من 35 يوماً</li>
                  <li>الحيض يستمر أقل من يومين أو أكثر من 7 أيام</li>
                  <li>النزيف شديد جداً (تغيير الفوطة كل ساعة)</li>
                  <li>النزيف خفيف جداً (بضع نقاط فقط)</li>
                </ul>
              </div>
              <div
                className="alert alert-info mt-3"
                style={{ lineHeight: "1.8", backgroundColor: "#d1ecf1" }}
              >
                <strong>💡 ملاحظة مهمة:</strong> ليس من الضروري أن تكون دورتك 28 يوماً
                بالضبط لتكون طبيعية. المهم هو الانتظام والثبات النسبي، وليس الرقم المحدد.
              </div>
            </div>
          </div>
          <div className="info-section">
            <div className="info-section-header">
              <h3 style={{ fontSize: "16px" }}>متى تحدث الإباضة؟</h3>
            </div>
            <div className="info-section-body">
              <p style={{ lineHeight: "1.8" }}>
                <strong>الإباضة</strong> (التبويض) تحدث عادةً في منتصف الدورة الشهرية، لكن
                التوقيت الدقيق يعتمد على طول دورتك.
              </p>
              <h4 style={{ fontSize: "16px", marginTop: "15px" }}>
                <strong>القاعدة الذهبية:</strong>
              </h4>
              <div
                className="alert alert-success"
                style={{ lineHeight: "1.8", backgroundColor: "#d4edda" }}
              >
                التبويض يحدث قبل <strong>14 يوماً</strong> من موعد الدورة القادمة (وليس بعد
                14 يوماً من آخر دورة).
              </div>
              <h4 style={{ fontSize: "16px", marginTop: "15px" }}>
                <strong>أمثلة حسب طول الدورة:</strong>
              </h4>
              <table className="table table-bordered" style={{ width: "100%" }}>
                <thead>
                  <tr style={{ backgroundColor: "#e7f3fe" }}>
                    <th style={{ textAlign: "center", padding: "12px" }}>
                      طول الدورة
                    </th>
                    <th style={{ textAlign: "center", padding: "12px" }}>
                      يوم التبويض
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style={{ textAlign: "center", padding: "10px" }}>
                      24 يوماً
                    </td>
                    <td style={{ textAlign: "center", padding: "10px" }}>
                      اليوم 10
                    </td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: "center", padding: "10px" }}>
                      28 يوماً
                    </td>
                    <td style={{ textAlign: "center", padding: "10px" }}>
                      اليوم 14
                    </td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: "center", padding: "10px" }}>
                      30 يوماً
                    </td>
                    <td style={{ textAlign: "center", padding: "10px" }}>
                      اليوم 16
                    </td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: "center", padding: "10px" }}>
                      32 يوماً
                    </td>
                    <td style={{ textAlign: "center", padding: "10px" }}>
                      اليوم 18
                    </td>
                  </tr>
                </tbody>
              </table>
              <h4 style={{ fontSize: "16px", marginTop: "15px" }}>
                <strong>فترة الخصوبة (النافذة الخصبة):</strong>
              </h4>
              <p style={{ lineHeight: "1.8" }}>
                فترة الخصوبة أوسع من يوم التبويض نفسه:
              </p>
              <ul style={{ lineHeight: "1.8" }}>
                <li>
                  <strong>5 أيام قبل التبويض:</strong> الحيوانات المنوية تعيش حتى 5 أيام
                </li>
                <li>
                  <strong>يوم التبويض:</strong> أعلى فرصة للحمل
                </li>
                <li>
                  <strong>يوم بعد التبويض:</strong> البويضة تعيش 12-24 ساعة
                </li>
              </ul>
              <div
                className="alert alert-info mt-3"
                style={{ lineHeight: "1.8", backgroundColor: "#d1ecf1" }}
              >
                <strong>💡 نصيحة:</strong> استخدمي <strong>حاسبة الدورة الشهرية</strong> أعلاه
                لتحديد أيام التبويض والخصوبة بدقة لمدة 12 شهراً قادماً.
              </div>
            </div>
          </div>
          <div className="info-section">
            <div className="info-section-header">
              <h3 style={{ fontSize: "16px" }}>
                ما هي أسباب تأخر الدورة الشهرية؟
              </h3>
            </div>
            <div className="info-section-body">
              <p style={{ lineHeight: "1.8" }}>
                هناك العديد من الأسباب التي قد تؤدي إلى <strong>تأخر الدورة الشهرية</strong>،
                وليس كلها يدعو للقلق:
              </p>
              <h4 style={{ fontSize: "16px", marginTop: "15px" }}>
                <strong>الأسباب الشائعة:</strong>
              </h4>
              <ol style={{ lineHeight: "1.8" }}>
                <li>
                  <strong>الحمل:</strong> السبب الأكثر شيوعاً لتوقف الدورة
                </li>
                <li>
                  <strong>التوتر والضغط النفسي:</strong> يؤثر على الهرمونات المنظمة للدورة
                </li>
                <li>
                  <strong>تغيرات الوزن:</strong> نقصان أو زيادة مفاجئة في الوزن
                </li>
                <li>
                  <strong>الرياضة المفرطة:</strong> خاصةً للرياضيات المحترفات
                </li>
                <li>
                  <strong>متلازمة تكيس المبايض (PCOS):</strong> اضطراب هرموني يؤثر على
                  التبويض
                </li>
                <li>
                  <strong>مشاكل الغدة الدرقية:</strong> قصور أو فرط النشاط
                </li>
                <li>
                  <strong>الرضاعة الطبيعية:</strong> تؤخر عودة الدورة طبيعياً
                </li>
                <li>
                  <strong>الأدوية:</strong> بعض الأدوية مثل مضادات الاكتئاب أو حبوب منع الحمل
                </li>
              </ol>
              <h4 style={{ fontSize: "16px", marginTop: "15px" }}>
                <strong>أسباب أخرى:</strong>
              </h4>
              <ul style={{ lineHeight: "1.8" }}>
                <li>السفر وتغيير المنطقة الزمنية</li>
                <li>اضطرابات الأكل (فقدان الشهية أو الشره)</li>
                <li>الأمراض المزمنة (السكري، أمراض القلب)</li>
                <li>قرب سن اليأس (فترة ما قبل انقطاع الطمث)</li>
                <li>التوقف عن حبوب منع الحمل مؤخراً</li>
              </ul>
              <h4 style={{ fontSize: "16px", marginTop: "15px" }}>
                <strong>متى تزورين الطبيب؟</strong>
              </h4>
              <div
                className="alert alert-danger"
                style={{ lineHeight: "1.8", backgroundColor: "#f8d7da" }}
              >
                <strong>⚠️ استشيري الطبيب إذا:</strong>
                <ul style={{ marginTop: "10px" }}>
                  <li>تأخرت الدورة أكثر من 3 أشهر (ولستِ حاملاً أو مرضعة)</li>
                  <li>أصبحت الدورة غير منتظمة فجأة بعد أن كانت منتظمة</li>
                  <li>ظهرت أعراض أخرى مثل ألم شديد، إفرازات غير طبيعية، أو نمو شعر زائد</li>
                  <li>عمرك أقل من 15 سنة ولم تبدأ الدورة بعد</li>
                </ul>
              </div>
              <div
                className="alert alert-info mt-3"
                style={{ lineHeight: "1.8", backgroundColor: "#d1ecf1" }}
              >
                <strong>💡 ملاحظة:</strong> تأخر الدورة بضعة أيام أمر طبيعي ولا يدعو للقلق.
                معظم النساء يختبرن تأخراً عرضياً في دوراتهن من حين لآخر.
              </div>
            </div>
          </div>
          <div className="info-section">
            <div className="info-section-header">
              <h3 style={{ fontSize: "16px" }}>
                كيف أخفف ألم الدورة الشهرية؟
              </h3>
            </div>
            <div className="info-section-body">
              <p style={{ lineHeight: "1.8" }}>
                <strong>ألم الدورة الشهرية</strong> (عسر الطمث) شائع جداً، ولكن هناك طرق
                فعالة لتخفيفه:
              </p>
              <h4 style={{ fontSize: "16px", marginTop: "15px" }}>
                <strong>العلاجات المنزلية:</strong>
              </h4>
              <ol style={{ lineHeight: "1.8" }}>
                <li>
                  <strong>الحرارة:</strong> استخدمي قربة ماء ساخن أو كمادات دافئة على البطن
                  والظهر
                </li>
                <li>
                  <strong>حمام دافئ:</strong> يساعد على استرخاء العضلات
                </li>
                <li>
                  <strong>التدليك:</strong> دلكي بطنك وأسفل ظهرك بحركات دائرية لطيفة
                </li>
                <li>
                  <strong>الرياضة الخفيفة:</strong> المشي، اليوغا، أو السباحة
                </li>
                <li>
                  <strong>الاسترخاء:</strong> تمارين التنفس العميق والتأمل
                </li>
              </ol>
              <h4 style={{ fontSize: "16px", marginTop: "15px" }}>
                <strong>الأدوية:</strong>
              </h4>
              <ul style={{ lineHeight: "1.8" }}>
                <li>
                  <strong>مسكنات الألم:</strong> الإيبوبروفين أو الباراسيتامول (تؤخذ عند
                  بداية الألم)
                </li>
                <li>
                  <strong>مضادات التشنج:</strong> تساعد على استرخاء عضلات الرحم
                </li>
                <li>
                  <strong>حبوب منع الحمل:</strong> قد تقلل من شدة الألم (استشيري الطبيب)
                </li>
              </ul>
              <h4 style={{ fontSize: "16px", marginTop: "15px" }}>
                <strong>نصائح غذائية:</strong>
              </h4>
              <div
                className="alert alert-success"
                style={{ lineHeight: "1.8", backgroundColor: "#d4edda" }}
              >
                <strong>تناولي:</strong>
                <ul style={{ marginTop: "10px" }}>
                  <li>الأطعمة الغنية بالحديد (لحم أحمر، سبانخ)</li>
                  <li>أوميجا 3 (سمك السلمون، المكسرات)</li>
                  <li>الفواكه والخضروات</li>
                  <li>الماء بكثرة</li>
                </ul>
                <br />
                <strong>تجنبي:</strong>
                <ul>
                  <li>الكافيين الزائد</li>
                  <li>الملح الزائد (يزيد الانتفاخ)</li>
                  <li>السكريات المصنعة</li>
                  <li>الكحول</li>
                </ul>
              </div>
              <h4 style={{ fontSize: "16px", marginTop: "15px" }}>
                <strong>متى تزورين الطبيب؟</strong>
              </h4>
              <div
                className="alert alert-warning"
                style={{ lineHeight: "1.8", backgroundColor: "#fff3cd" }}
              >
                <strong>⚠️ استشيري الطبيب إذا:</strong>
                <ul style={{ marginTop: "10px" }}>
                  <li>الألم شديد لدرجة أنه يمنعك من القيام بأنشطتك اليومية</li>
                  <li>المسكنات العادية لا تخفف الألم</li>
                  <li>الألم يزداد سوءاً مع الوقت</li>
                  <li>ظهرت أعراض جديدة مثل نزيف شديد أو حمى</li>
                  <li>عمرك أكثر من 25 سنة وبدأ الألم فجأة</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default PeriodEducationalContent;